import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('gst_user')); } catch { return null; }
  });

  const login = (userData) => {
    setUser(userData);
    sessionStorage.setItem('gst_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('gst_user');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);


// import { createContext, useContext, useState } from 'react';

// const HARDCODED_EMAIL    = 'admin@finkraft.ai';
// const HARDCODED_PASSWORD = 'password123';

// const AuthContext = createContext(null);

// export function AuthProvider({ children }) {
//   const [user, setUser] = useState(null);

//   const login = ({ email, password }) => {
//     if (email === HARDCODED_EMAIL && password === HARDCODED_PASSWORD) {
//       setUser({ email });
//       return true;
//     }
//     return false;
//   };

//   const logout = () => setUser(null);

//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export function useAuth() {
//   return useContext(AuthContext);
// }